// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"38467be4","277":"443b31cb","308":"842eb00a","496":"2054e479"}[chunkId] + ".chunk.js";
};